module.exports = __webpack_public_path__ + "img/chat-box.aa35f69e.png";